import * as React from "react";

import { ILeanSvgIcon } from "../ILeanSvgIcon";
// tslint:disable
export const yammer_praise_glasses: React.FunctionComponent<ILeanSvgIcon> = ({ ...rest }) => {
  return (
    <svg viewBox="0 0 150 150" id="yk-svg-praise-glasses" {...rest}>
      <title>praise-glasses</title>
      <ellipse
        transform="rotate(-88.267 74.997 75.003) scale(.99996)"
        fill="#FB7F78"
        cx="75"
        cy="75"
        rx="75"
        ry="75"
        opacity=".8"
      ></ellipse>
      <path fill="#9E3028" stroke="#9E3028" strokeWidth=".5" strokeMiterlimit="10" d="M70.2 72.6h12.2v5.2H70.2z"></path>
      <path
        fill="#FFF"
        d="M54.3 98.8H27.2c-3.4 0-6.2-2.7-6.4-6.1l-1-17.8c-.2-3.7 2.7-6.8 6.4-6.8h36.5c4.1 0 7.1 3.7 6.3 7.7l-2.6 13.1c-1.1 5.7-6.2 9.9-12.1 9.9z"
      ></path>
      <path
        fill="#9E3028"
        stroke="#9E3028"
        strokeWidth=".5"
        strokeMiterlimit="10"
        d="M62.6 68.1c4.1 0 7.1 3.7 6.3 7.7l-2.6 13.1c-1.1 5.8-6.2 9.9-12.1 9.9h-27c-3.4 0-6.2-2.7-6.4-6.1l-1-17.8c-.2-3.7 2.7-6.8 6.4-6.8h36.4m0-5.2H26.2c-3.2 0-6.3 1.3-8.5 3.6s-3.3 5.5-3.2 8.7l1 17.8c.3 6.2 5.5 11 11.6 11h27.2c8.4 0 15.6-5.9 17.2-14.1l2.6-13.1c.7-3.4-.2-6.9-2.4-9.6-2.3-2.8-5.6-4.3-9.1-4.3z"
      ></path>
      <path
        fill="#FFF"
        d="M98.7 98.8h27.2c3.4 0 6.2-2.7 6.4-6.1l1-17.8c.2-3.7-2.7-6.8-6.4-6.8H90.4c-4.1 0-7.1 3.7-6.3 7.7l2.6 13.1c1.1 5.7 6.1 9.9 12 9.9z"
      ></path>
      <path
        fill="#9E3028"
        stroke="#9E3028"
        strokeWidth=".5"
        strokeMiterlimit="10"
        d="M126.9 68.1c3.7 0 6.6 3.1 6.4 6.8l-1 17.8c-.2 3.4-3 6.1-6.4 6.1H98.7c-5.9 0-10.9-4.2-12.1-9.9L84 75.8c-.8-4 2.3-7.7 6.3-7.7h36.6m0-5.2H90.4c-3.5 0-6.8 1.5-9 4.2s-3.1 6.2-2.4 9.6l2.6 13.1C83.2 98 90.4 104 98.7 104h27.2c6.2 0 11.3-4.8 11.6-11l1-17.8c.2-3.2-1-6.3-3.2-8.7-2.1-2.3-5.2-3.6-8.4-3.6z"
      ></path>
      <path
        fill="#9E3028"
        stroke="#9E3028"
        strokeWidth=".5"
        strokeMiterlimit="10"
        d="M20.6 70.2c-.8 0-1.6-.4-2.1-1.1-.9-1.2-.6-2.8.5-3.6l41.8-31.1c1.1-.8 2.7-.6 3.5.4l5.9 7c.9 1.1.8 2.7-.3 3.7-1.1.9-2.7.8-3.7-.3L62 40.1 22.2 69.7c-.5.3-1 .5-1.6.5zm112 0c-.5 0-1.1-.2-1.6-.5L91.2 40.1l-4.3 5.1c-.9 1.1-2.6 1.2-3.7.3s-1.2-2.6-.3-3.7l5.9-7c.9-1.1 2.4-1.2 3.5-.4l41.8 31.1c1.2.9 1.4 2.5.5 3.6-.4.7-1.2 1.1-2 1.1z"
      ></path>
    </svg>
  );
};
